/* import __COLOCATED_TEMPLATE__ from './fly-accordion.hbs.js'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
let FlyAccordion = (_class = class FlyAccordion extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "activeItemIds", _descriptor, this);
    _initializerDefineProperty(this, "itemIds", _descriptor2, this);
  }
  get showToggleStateIcon() {
    return this.args.showToggleStateIcon ?? true;
  }
  get initiallyOpened() {
    return this.args.initiallyOpened ?? false;
  }
  get allowMultipleOpenItems() {
    return this.initiallyOpened || (this.args.allowMultipleOpenItems ?? false);
  }
  onMutate(mutationList) {
    for (let mutation of mutationList) {
      let {
        type,
        attributeName,
        target
      } = mutation;
      if (type === 'attributes' && attributeName === 'open') {
        let {
          id,
          open,
          ariaDisabled
        } = target;
        if (open === true && ariaDisabled === null) {
          this.openItem(id);
        } else if (open === false) {
          this.closeItem(id);
        }
      }
    }
  }
  openItem(id) {
    if (!this.allowMultipleOpenItems) {
      this.activeItemIds = [];
    }
    this.activeItemIds = [...this.activeItemIds, id];
    this.args.onExpand?.(id);
  }
  closeItem(id) {
    this.activeItemIds = this.activeItemIds.filter(activeItemId => id !== activeItemId);
    this.args.onCollapse?.(id);
  }
  registerItem(id, initiallyOpened) {
    this.itemIds.push(id);
    if (initiallyOpened) {
      this.activeItemIds.push(id);
      // if initiallyOpened is set on the accordion.item component and
      // there are multiple items with initiallyOpened set to true but
      // allowMultipleOpenItems is false, throw an error
      if (this.activeItemIds.length > 1 && !this.allowMultipleOpenItems) {
        throw new Error('Only one accordion item can be initially opened when allowMultipleItemsOpen is false');
      }
    }
  }
  unregisterItem(id) {
    this.itemIds.splice(this.itemIds.indexOf(id), 1);
  }
  openAllItems() {
    this.activeItemIds = [...this.itemIds];
  }
  closeAllItems() {
    this.activeItemIds = [];
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "activeItemIds", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "itemIds", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "onMutate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onMutate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openItem", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeItem", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "registerItem", [action], Object.getOwnPropertyDescriptor(_class.prototype, "registerItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unregisterItem", [action], Object.getOwnPropertyDescriptor(_class.prototype, "unregisterItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openAllItems", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openAllItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeAllItems", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeAllItems"), _class.prototype)), _class);
export { FlyAccordion as default };